/* "Does it fit" filter inputs (filter audit 2026-10-07, snippets/pv-facet-fit.liquid).
   A typed number becomes the matching grid value in the row's hidden input, which
   facets.js submits as an ordinary filter param. Maks rounds DOWN and minst rounds UP,
   so a result never breaks the customer's limit. Listeners sit on document in the
   capture phase: they survive facets.js re-rendering the drawer, and they run before
   the form's debounced submit handler reads the form. */
(() => {
  if (window.pvFacetFit) return;
  window.pvFacetFit = true;

  const expand = (spec) =>
    spec.split(',').flatMap((part) => {
      const [from, to, step] = part.split(':').map(Number);
      const out = [];
      for (let v = from; v <= to; v += step) out.push(v);
      return out;
    });

  const sync = (input) => {
    const row = input.closest('[data-pv-fit-row]');
    if (!row) return;
    const hidden = row.querySelector('input[type="hidden"]');
    const note = row.querySelector('[data-pv-fit-note]');
    const typed = parseInt(String(input.value).replace(/\D/g, ''), 10);
    const grid = expand(row.dataset.grid);
    const isMax = row.dataset.mode === 'max';
    let target;
    if (!typed || (isMax && typed < grid[0])) {
      target = null; // empty or still typing the first digits
    } else if (isMax) {
      target = grid.filter((g) => g <= typed).pop();
    } else {
      target = grid.find((g) => g >= typed);
      if (target === undefined) target = 99999; // stronger than anything we sell
    }
    hidden.disabled = target === null;
    hidden.value = target === null ? '' : `${row.dataset.prefix}${target}${row.dataset.suffix}`;
    if (note) {
      note.textContent =
        target !== null && target !== typed && target !== 99999
          ? row.dataset.roundNote.replace('{n}', target)
          : '';
    }
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest && event.target.closest('[data-pv-fit-input]');
      if (input) sync(input);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-pv-fit-input]')) {
      event.preventDefault();
      event.target.blur();
    }
  });

  document.addEventListener('click', (event) => {
    const clear = event.target.closest && event.target.closest('[data-pv-fit-clear]');
    if (!clear) return;
    event.preventDefault();
    const group = clear.closest('.pv-fit');
    const inputs = group ? group.querySelectorAll('[data-pv-fit-input]') : [];
    inputs.forEach((input) => {
      input.value = '';
      sync(input);
    });
    if (inputs[0]) inputs[0].dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
